import React from "react";
import {
    StyleSheet,
    Text,
    View,
    ImageBackground,
    ScrollView,
    TouchableOpacity,
    TextInput,
    Alert,
    // ToastAndroid,
    Image,
    Share
} from 'react-native';

import Config from "../components/Config";

import * as Clipboard from 'expo-clipboard';

import {RFValue} from "react-native-responsive-fontsize";

import { Ionicons } from '@expo/vector-icons';

import {useFocusEffect} from "@react-navigation/native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";

import { FontAwesome5 } from '@expo/vector-icons';
import { AntDesign } from '@expo/vector-icons';
// import Toast from 'react-native-tiny-toast';
import ToastNotification from 'react-native-toast-notification'
const Invation = ({navigation})=>{

    useFocusEffect(
        React.useCallback(() => {
            getData();
        }, [])
    );


    let [profile,setProfile] = React.useState({
        left : 'Loading ... ',
        right : 'Loading ... '
    });

    let [toast,setToast] = React.useState(false);
    const getData = async ()=>{
        let token = await AsyncStorage.getItem('token');



        let res = await axios.get(
            `${Config.base}/api/v1/profile`,
            { params:
                    {
                        token: token
                    }
            }
        );
        profile = res.data;
        setProfile(res.data);
    };

    const copyToClipboard = async (data) => {


        await Clipboard.setStringAsync(data);

        setToast('copy has successfully !');

        const timeoutId = setTimeout(() => {
            setToast(false);
        }, 3000);
        // Toast.showSuccess('copy has successfully !');
        // ToastAndroid.show('copy has successfully !', ToastAndroid.SHORT);
    };

    const Shares = async (data) => {
        const result = await Share.share({
            message: data
        });




    };




    return (
        <View style={{flex : 1}}>
            <ImageBackground
                source={{uri: 'https://metamax.network/public/appBg.jpg'}}
                // source={{uri: 'https://img.freepik.com/free-photo/minimalistic-still-life-arrangement-with-cryptocurrency_23-2149102090.jpg?w=740&t=st=1694093218~exp=1694093818~hmac=d9334eec05ae93b0588ef7cd2b5b01df82be982db4bb333380c6e5760732c18e'}}
                resizeMode="cover" style={{flex : 1}}>
                <View style={styles.headercon}>
                    <TouchableOpacity style={{backgroundColor : 'transparent'}} onPress={()=>navigation.goBack()}>
                        <Ionicons   name="return-up-back" size={RFValue(35)} color="#FFF" />
                    </TouchableOpacity>

                    <Text style={styles.header}>
                        Invation
                    </Text>
                </View>






                <View style={{flex : 1,justifyContent : 'center'}}>
                    <View style={styles.box2}>

                        {/*<View>*/}

                        {/*    <Image*/}
                        {/*        resizeMode={'stretch'}*/}
                        {/*        fadeDuration={999}*/}
                        {/*        style={{*/}
                        {/*            width : RFValue(150),*/}
                        {/*            height :RFValue(150),*/}
                        {/*            marginVertical : RFValue(5),*/}
                        {/*            borderRadius : 2,*/}
                        {/*            alignSelf : 'center'*/}
                        {/*        }}*/}

                        {/*        source={{uri : `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${profile.left}`}}*/}
                        {/*    />*/}
                        {/*  <View style={{flexDirection :'row', justifyContent : 'space-between', alignItems : 'center'}}>*/}
                        {/*      <Text style={styles.label}>*/}
                        {/*          Left :*/}
                        {/*      </Text>*/}

                        {/*     <View style={{flexDirection : 'row'}}>*/}
                        {/*         <FontAwesome5 style={{marginHorizontal : RFValue(5)}} onPress={()=>copyToClipboard(profile.left)} name="copy" size={RFValue(16)} color="#f6f6f6" />*/}
                        {/*         <AntDesign style={{marginHorizontal : RFValue(5)}}  onPress={()=>Shares(profile.left)} name="sharealt" size={RFValue(16)} color="#f6f6f6" />*/}
                        {/*     </View>*/}


                        {/*  </View>*/}
                        {/*    <View style={{flexDirection : 'row'}}>*/}
                        {/*        <TextInput editable={false} value={profile.left} placeholder={'Enter Address'} style={styles.textinput}/>*/}
                        {/*    </View>*/}
                        {/*</View>*/}

                        <View style={{marginTop : -RFValue(50)}}>
                            <Image
                                resizeMode={'stretch'}
                                fadeDuration={999}
                                style={{
                                    width : RFValue(190),
                                    height :RFValue(190),
                                    marginVertical : RFValue(5),
                                    padding : RFValue(0),
                                    borderRadius : 2,
                                    alignSelf : 'center'
                                }}

                                source={{uri : `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${profile.right}`}}
                            />
                            {toast.length &&
                                <ToastNotification
                                    // textStyle={{ color: 'red' }}
                                    // style={{ backgroundColor: 'yellow' }}
                                    text={toast}
                                    // duration={99999999999}
                                    isTop={true}
                                    style={{ padding: RFValue(10) }}
                                />
                            }
                            <View style={{flexDirection :'row', justifyContent : 'space-between', alignItems : 'center'}}>
                                <Text style={styles.label}>
                                    Referral :
                                </Text>


                                <View style={{flexDirection : 'row'}}>
                                    <FontAwesome5 style={{marginHorizontal : RFValue(5)}} onPress={()=>copyToClipboard(profile.right)} name="copy" size={RFValue(16)} color="#f6f6f6" />
                                    <AntDesign style={{marginHorizontal : RFValue(5)}}  onPress={()=>Shares(profile.right)} name="sharealt" size={RFValue(16)} color="#f6f6f6" />
                                </View>


                            </View>
                            <View style={{flexDirection : 'row'}}>
                                <TextInput editable={false} value={profile.right} placeholder={'Enter Address'} style={styles.textinput}/>
                            </View>
                        </View>


                    </View>

                </View>


            </ImageBackground>




        </View>
    );
}


const styles = StyleSheet.create({
    spanStyle : {
        position : 'absolute',
        right : RFValue(10),
        top : RFValue(5),
        color : '#FFF',
        fontSize : RFValue(25)
    },
    recivetext : {
        fontFamily : 'novaria',
        color : '#f6f6f6',
        textAlign : 'center',
        fontSize : RFValue(14),
        display : 'none' ,
        paddingVertical : RFValue(5)
    },

    textfee:{
        fontFamily : 'novaria',
        color : '#e1e1e1',
        // textAlign : 'center',
        fontSize : RFValue(12),
        paddingVertical : RFValue(10),
    },

    label:{
        fontFamily : 'novaria',
        color : '#f6f6f6',
        // textAlign : 'center',
        fontSize : RFValue(16),
        paddingVertical : RFValue(10)
    },
    textinput : {
        fontSize : RFValue(13),
        paddingVertical : RFValue(10),
        paddingHorizontal : RFValue(15),
        borderWidth : 1,
        color : '#e1e1e1',
        borderColor : '#f6f6f6',
        width : '100%',
        borderRadius : RFValue(4)

    },


    btn2 : {

        borderWidth : 1,
        borderColor : 'transparent',
        width : '30%',
        margin : "auto",
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(5),
        borderRadius : RFValue(5),
        backgroundColor : '#009688'
    },

    btn : {

        borderWidth : 1,
        borderColor : '#FFF',
        width : RFValue(120),
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(3),
        borderRadius : RFValue(5),
        backgroundColor : 'transparent',
        marginHorizontal : RFValue(5)
    },

    btntext : {
        color : '#FFF',
        fontFamily : 'novaria',
    },



    box2 : {
        margin : RFValue(12),
        backgroundColor : 'transparent',
        padding:RFValue(5),
        borderRadius : RFValue(10),
        // flex : 1,
        // flexDirection : 'row',
    },


    headercon : {
        backgroundColor : 'transparent',
        flexDirection : 'row',
        alignItems : "center",
        paddingVertical : RFValue(3),
        paddingHorizontal : RFValue(25),
        // borderTopWidth : 1,
        // borderTopColor : '#FFF',

        borderBottomWidth : 1,
        borderBottomColor : '#f6f6f6',

    },
    header : {
        fontFamily : 'novaria',
        color : '#FFF',
        textAlign : 'center',
        fontSize : RFValue(20),
        padding : RFValue(20),

        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3,
        flex : 1,
        marginRight : RFValue(20)


    },



});


export default Invation;
